import { motion } from 'framer-motion';
import sun from './sun.svg';
import moon from './moon.svg';
import { useState } from 'react';

const togvars = {
    'light' : {
        'filter': 'invert(0%) sepia(0%) saturate(0%) hue-rotate(106deg) brightness(92%) contrast(104%)',
        // 'border': '0.05rem solid rgb(255, 255, 255)'
    },
    'dark' : {
        'filter': 'invert(100%) sepia(100%) saturate(0%) hue-rotate(161deg) brightness(101%) contrast(100%)',
        // 'border': '0.05rem solid rgb(255, 255, 255)'
    },
};

const rootvars = {
    'light' : {
        'border': '0.1rem solid rgb(0, 0, 0)',
        'border-bottom': '0.2rem solid black'
    },
    'dark' : {
        'border': '0.1rem solid rgb(255, 255, 255)',
        'border-bottom': '0.2rem solid white'
    },
};


export default function Toggle({ handleChange, val }) {
    
    const [mode, setMode] = useState(val);
    
    return (
        <motion.div 
            className="toggleroot"
            onClick={() => {
                setMode(mode === 'light' ? 'dark' : 'light');
                handleChange(mode === 'light' ? 'dark' : 'light');
            }}
            variants={rootvars}
            initial={mode}
            animate={mode}
            whileTap={{
                'border-bottom': (mode === 'light') ? '0.1rem solid rgb(0, 0, 0)' : '0.1rem solid rgb(255, 255, 255)'
            }}
        >
            <motion.img 
                src={mode === 'light' ? sun : moon} 
                className='toggle'
                variants={togvars}
                initial={mode}
                animate={mode}
            />
        </motion.div>
    );
}